export enum TYPES {
  BANK = 'banks',
  INSURANCE = 'insuranceCompany',
  MFI = 'mfi',
  BANK_RATING = 'bankRating',
  INSURANCE_RATING = 'insuranceRating',
  MFI_RATING = 'mfiRating',
}

export const TYPES_MAP_FROM_RATING_SERVICE = {
  banks: TYPES.BANK,
  insuranceCompany: TYPES.INSURANCE,
  mfi: TYPES.MFI,
};

export type TTab = {
  label: string;
  value: TYPES;
  link: string;
  linkText: string;
};

export type TOrganizationTypes = TYPES.BANK | TYPES.INSURANCE | TYPES.MFI;

export const TABS: Record<TOrganizationTypes, TTab> = {
  [TYPES.BANK]: {
    label: 'Банки',
    value: TYPES.BANK,
    link: '/banki/',
    linkText: 'Все банки',
  },
  [TYPES.INSURANCE]: {
    label: 'Страховые компании',
    value: TYPES.INSURANCE,
    link: '/strakhovye-kompanii/',
    linkText: 'Все страховые компании',
  },
  [TYPES.MFI]: {
    label: 'МФО',
    value: TYPES.MFI,
    link: '/zaimy/mfo/',
    linkText: 'Все МФО',
  },
};

export const FETCH_PARAMS = {
  [TYPES.BANK]: {
    statuses: ['active'],
    types: 'bank',
    select: ['isPremiumPartner', 'id', 'oldId', 'alias', 'logotypes', 'name.short', 'type'],
  },
  [TYPES.MFI]: {
    statuses: ['active'],
    types: 'mfo',
    select: ['partnerCard', 'id', 'oldId', 'alias', 'logotypes', 'name.short', 'type'],
  },
  [TYPES.INSURANCE]: { status: 'Active' },
  [TYPES.BANK_RATING]: { OrganizationType: 'banks', ReviewTag: 'unknown' },
  [TYPES.MFI_RATING]: { OrganizationType: 'mfi', ReviewTag: 'unknown' },
  [TYPES.INSURANCE_RATING]: { OrganizationType: 'insuranceCompany', ReviewTag: 'unknown' },
};
